<template>
  <div class="header-sticky-wrapper">
    <div class="header-wrapper van-safe-area-top" ref="headerBarRef">
      <header-download />
      <van-nav-bar left-arrow safe-area-inset-top>
        <template #left>
          <div class="flex-center">
            <svg-icon
              class="left-menu-icon"
              :icon-name="showLeftPopup ? 'menu-fold' : 'menu-unfold'"
              :height="57"
              @click="changeShowLeftPopup"
              v-if="isShowLeftPopup"
            />
            <router-link to="/home">
              <img class="logo" v-lazy="logoSrc" />
            </router-link>
          </div>
          <van-search
            v-if="
              typeof router.currentRoute.value.name === 'string' && router.currentRoute.value.name.includes('video')
            "
            v-model="searchValue"
            @click="onSearch"
            shape="round"
            placeholder="大家都在搜"
          >
            <template #left-icon>
              <svg-icon class="search-icon" icon-name="search" :height="46" />
            </template>
          </van-search>
        </template>
        <template #right>
          <wallet-amount :link-deposit="isLinkDeposit" v-if="isLogin" />
          <van-space :size="10" v-else>
            <van-button class="action-btn" type="primary" round plain @click="showLoginModel(2)">注册</van-button>
            <van-button class="action-btn" type="primary" round @click="showLoginModel(1)">登录</van-button>
          </van-space>
        </template>
      </van-nav-bar>
    </div>
    <div class="van-safe-area-top" :style="{ height: `${headerHeight}px` }"></div>
  </div>
  <left-popup v-model="showLeftPopup" />
</template>

<script setup lang="ts">
import { computed, defineAsyncComponent, ref, watch } from 'vue';
import { useElementSize } from '@vueuse/core';
import { storeToRefs, useAppStore, useTenantStore, useUserStore } from '@star/stores';
import { emitter, EventEnum } from '@star/utils';
import { ThemeEnum } from '@star/constants';
import { includes } from 'lodash-es';
import { useRoute, useRouter } from 'vue-router';
import HeaderDownload from './components/HeaderDownload/index.vue';
// import { G_goRegister } from '@/plugins/public_utils';

const router = useRouter();
const route = useRoute();

const LeftPopup = defineAsyncComponent(() => import('./components/leftPopup/index.vue'));
const WalletAmount = defineAsyncComponent(() => import('@/components/WalletAmount/index.vue'));

const appStore = useAppStore();
const { isLogin } = storeToRefs(useUserStore());
const { logoSrc } = storeToRefs(useTenantStore());
const { theme } = storeToRefs(appStore);

const showLeftPopup = ref(false);
const headerBarRef = ref<any>();
const searchValue = ref<string>();
const { height: headerHeight } = useElementSize(headerBarRef);

const isShowLeftPopup = computed(() => {
  return includes([ThemeEnum.LIGHT], theme.value);
});

const isLinkDeposit = computed(() => {
  return includes(['home'], route?.name);
});

const onSearch = (value: string) => {
  router.push('/search');
};

const changeShowLeftPopup = () => {
  showLeftPopup.value = !showLeftPopup.value;
};

const showLoginModel = (type: 0 | 1 | 2) => {
  emitter.emit(EventEnum.LOGIN, { type });
};

watch(
  () => headerHeight.value,
  val => {
    appStore.setHeaderHeight(val);
  },
  { immediate: true }
);
</script>

<style scoped lang="less">
.header-wrapper {
  background-color: var(--theme-backgroud-color);
  display: flex;
  flex-direction: column;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;

  .left-menu-icon {
    margin-right: 20px;
  }

  .logo {
    max-width: 588px;
    max-height: 100px;
    margin-top: 6px;
  }

  :deep(.van-search) {
    width: 345px;
    height: 90px;
    padding: 0;

    &__content {
      background: #f6f6f7;
      padding-left: 30px;
      height: 100%;
    }

    &__field {
      height: 100%;
      line-height: 1;
    }

    &__action {
      line-height: 1;
      padding: 0;
    }

    .van-field {
      height: 100%;
      &__value {
        height: 100%;
      }

      &__body {
        height: 100%;
      }
      &__control {
        height: 90px;
      }
    }
  }

  :deep(.van-nav-bar) {
    width: 100%;
    height: var(--header-height);

    .van-nav-bar__content {
      height: 100%;
    }

    .van-nav-bar__left {
      padding: 0 30px;
      flex: 1;
    }

    .van-nav-bar__right {
      padding: 0 30px;
    }
  }

  .register {
    color: var(--theme-btn-primary-color);
    background-color: var(--theme-btn-plain-background);
    border: 3px solid #4edef1;
  }

  .login {
    color: var(--theme-btn-plain-background);
    background-color: var(--theme-btn-primary-background);
  }

  .action-btn {
    border-radius: 50px;
    font-size: 42px;
    height: 72px;
    padding: 0 36px;
    line-height: 1;
  }
}
</style>
